import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container, MenuItem,

} from '@mui/material';

import {
    StyledTableHeadRow,
    StyledTableCell,
    StyledTableBodyRow, StyledTable, StyledTableCellHeader, StyledButtonContainer, StyledButtonOrange
} from "../../../styles/MyStyles";

import {useNavigate} from "react-router-dom";
import {GetEnumValueName} from "../../../logic/EnumHelper";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";

const ClientsPage = () => {
    const [clients, setClients] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const [selectedType, setSelectedType] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRowTap = (clientId) => {
        navigate(`/contacts/clients/${clientId}`);
    };

    const createClient = () => {
        navigate(`/contacts/clients/0`);
    };

    const handleTypeFilter = (event) => {
        setSelectedType(event.target.value);
    };

    const filteredClients = clients.filter((client) =>
        client.email.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedType === '' || client.type === parseInt(selectedType))
    );

    const totalClients = filteredClients.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedClients = filteredClients.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Type"
                        value={selectedType}
                        onChange={handleTypeFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="0">Private</MenuItem>
                        <MenuItem value="1">Legal</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createClient} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={6}>Client ID</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={6}>Dossier Id</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={6}>Email</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={6}>Name</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={6}>Type</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={6}>High Risk</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedClients.map((client) => (
                                <StyledTableBodyRow
                                    key={client.id}
                                    onClick={() => handleRowTap(client.id)}>
                                    <StyledTableCell>{client.id}</StyledTableCell>
                                    <StyledTableCell>{client.dossierId}</StyledTableCell>
                                    <StyledTableCell>{client.email}</StyledTableCell>
                                    <StyledTableCell>{GetClientViewName(client)}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('clientType', client.type)}</StyledTableCell>
                                    <StyledTableCell>{client.highRisk ? 'Yes' : 'No'}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalClients}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ClientsPage;
